import { TaskObjectNaming } from "@jugl-web/rest-api/tasks";

export const guestSharingOptions = [
  "showTaskDetails",
  "showSubtaskDetails",
  "showTaskAttachments",
  "showSubtaskAttachments",
  "showInvoiceDocuments",
] as const;

export type GuestSharingOption = (typeof guestSharingOptions)[number];

interface TaskObjectNamingPreset extends TaskObjectNaming {
  id: string;
}

export const taskObjectNamingPresets = [
  { id: "task", singular: "Task", plural: "Tasks" },
  { id: "budget", singular: "Budget", plural: "Budgets" },
  { id: "item", singular: "Item", plural: "Items" },
  { id: "creative", singular: "Creative", plural: "Creatives" },
  { id: "project", singular: "Project", plural: "Projects" },
  { id: "campaign", singular: "Campaign", plural: "Campaigns" },
  { id: "ticket", singular: "Ticket", plural: "Tickets" },
  { id: "client", singular: "Client", plural: "Clients" },
  { id: "order", singular: "Order", plural: "Orders" },
] as const satisfies TaskObjectNamingPreset[];

export interface ManageBoardFormValues {
  color: string;
  name: string;
  description: string;
  owners: string[];
  members: string[];
  viewers: string[];
  prefix: string;
  taskObjectNamingId: (typeof taskObjectNamingPresets)[number]["id"] | "custom";
  customTaskObjectNaming: TaskObjectNaming;
  includeBillingFiles: boolean;
  includeOrderDetails: boolean;
}
